<template>
  <div>
    <div class="topicSelectionContainer">
      <div
        class="topicSelectionLoadingCircle"
        v-bind:style="
          isLoaded == false ? { display: 'flex' } : { display: 'none' }
        "
      >
        <div class="loader"></div>
      </div>
      <div class="topicSelectionHeader" v-if="isLoaded">Topic Selection</div>
      <table
        class="singleTopicContainer"
        v-for="(topic, index) in topicData"
        :key="index"
      >
        <tr>
          <th
            :class="topic.isActive ? 'header active' : 'header'"
            @click="changeVideoTimeToTopicTime(topic)"
          >
            {{ topic.title }}
          </th>
          <th>
            <span v-if="!topic.isActive"
              >{{ topic.start }}
              <!--<span v-if="!topic.isActive"
                >({{ topic.timeDifference }})</span
              >--></span>
            <span v-if="topic.isActive">{{ topic.remainingTime }}</span>
          </th>
        </tr>
        <tr v-for="(subTopic, indexx) in topic.timings" :key="indexx"
        :class="subTopic.isActive ? 'subTopic active' : 'subTopic'">
          <td>
            <play-icon v-if="subTopic.isActive"></play-icon>

            <span
              class="subTopicText"
              @click="changeVideoTimeToSubTopicTime(subTopic)"
            >
              {{ subTopic.subTitle }}
            </span>
          </td>

          <td>
            <span v-if="!subTopic.isActive">
              <span v-for="(time, indexxx) in subTopic.time" :key="indexxx"
                >{{ time.start
                }}<span v-if="subTopic.time.length - 1 != indexxx"
                  >, </span
                ></span
              >
            </span>
            <span v-if="subTopic.isActive">
              {{ subTopic.remainingTime }}</span
            >
            <!--<span v-if="!subTopic.isActive">
              ({{ subTopic.timeDifference }})</span
            >-->
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { LoadTopicDataFromGoogleSheet } from "../general-functions";
import "../scss/topicSelection.css";
import Vue from "vue";
import timeMixin from "../mixins/timeMixin";

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  components: {},
  async mounted() {},
  methods: {
    changeVideoTimeToSubTopicTime(subTopic) {
      if (this.initialPrefs.sendEventsToDataLayer) {
        this.$gtag.event("videoEvent", {
          videoCategory: "Springer Healthcare Interactive Video",
          videoAction: "Video Interaction: click on the subtopic",
          videoId: this.initialPrefs.videoID,
          videoName: this.initialPrefs.projectName,
          videoLive: "false",
          videoSection: subTopic.title,
        });
      }
      this.$root.$emit("seekVideo", subTopic.time[0].parsedStart);
      this.$root.$emit("playVideo");
    },
    changeVideoTimeToTopicTime(topic) {
      if (this.initialPrefs.sendEventsToDataLayer) {
        this.$gtag.event("videoEvent", {
          videoCategory: "Springer Healthcare Interactive Video",
          videoAction: "Video Interaction: click on the topic",
          videoId: this.initialPrefs.videoID,
          videoName: this.initialPrefs.projectName,
          videoLive: "false",
          videoSection: topic.title,
        });
      }
      this.$root.$emit("seekVideo", topic.parsedStart);
      this.$root.$emit("playVideo");
    },
    async onVisible() {
      var loadedData = await LoadTopicDataFromGoogleSheet(this.data.sheetsURL);
      loadedData.forEach((element) => {
        var singleTopicData = {};
        singleTopicData.title = element.Topic[0];
        singleTopicData.timings = [];
        var startTimeText = "",
          endTimeText = "",
          startTime = Infinity,
          endTime = 0;
        for (var i = 1; i < element.Topic.length; i++) {
          var index = singleTopicData.timings.findIndex(
            (x) => x.subTitle == element.Topic[i]
          );
          var parsedStart = this.convertHoursMinsSecsToSeconds(
            element.start[i]
          );
          var parsedEnd = this.convertHoursMinsSecsToSeconds(element.end[i]);
          if (parsedStart < startTime) {
            startTime = parsedStart;
            startTimeText = element.start[i];
          }
          if (parsedEnd > endTime) {
            endTime = parsedEnd;
            endTimeText = element.end[i];
          }
          if (index == -1) {
            singleTopicData.timings.push({
              subTitle: element.Topic[i],
              isActive: false,
              remainingTime: "",
              timeDifference: this.convertSecondsToHourMinsSecs(
                parsedEnd - parsedStart
              ),
              time: [
                {
                  start: element.start[i],
                  end: element.end[i],
                  parsedStart: parsedStart,
                  parsedEnd: parsedEnd,
                },
              ],
            });
          } else {
            singleTopicData.timings[index].time.push({
              start: element.start[i],
              end: element.end[i],
              timeDifference: this.convertSecondsToHourMinsSecs(
                parsedEnd - parsedStart
              ),
              parsedStart: parsedStart,
              parsedEnd: parsedEnd,
              isActive: false,
            });
          }
        }
        singleTopicData.start = startTimeText;
        singleTopicData.end = endTimeText;
        singleTopicData.parsedStart = startTime;
        singleTopicData.parsedEnd = endTime;
        Vue.set(
          singleTopicData,
          "timeDifference",
          this.convertSecondsToHourMinsSecs(endTime - startTime)
        );
        Vue.set(singleTopicData, "remainingTime", "");
        this.topicData.push(singleTopicData);
      });
      this.isLoaded = true;
      this.$nextTick(() => {
        this.$parent.resize();
      });
    },
    async runFirstLoad() {
      await this.onVisible();
    },
    process(time) {
      this.topicData.forEach((element) => {
        if (time > element.parsedStart && time < element.parsedEnd) {
          element.timings.forEach((subTopic) => {
            var isActive = false;
            for (var i = 0; i < subTopic.time.length; i++) {
              if (
                time > subTopic.time[i].parsedStart &&
                time < subTopic.time[i].parsedEnd
              ) {
                subTopic.isActive = true;
                isActive = true;
                var remainingTime = subTopic.time[i].parsedEnd - time;
                subTopic.remainingTime =
                  this.convertSecondsToHourMinsSecs(remainingTime);
                break;
              }
            }
            if (isActive == false) {
              subTopic.isActive = false;
            }
          });
          element.isActive = true;
          element.remainingTime = this.convertSecondsToHourMinsSecs(
            element.parsedEnd - time
          );
        } else if (element.isActive) {
          element.timings.forEach((subTopic) => {
            if (subTopic.isActive) {
              subTopic.isActive = false;
            }
          });
          element.isActive = false;
        }
      });
    },
  },
  data() {
    return {
      topicData: [],
      isLoaded: false,
    };
  },
  mixins: [timeMixin],
};
</script>
